<template lang="pug">
  v-row.lesson-edit
    v-col(
      cols="12"
      sm=12
      md=7
    )
      v-list(color="transparent")
        // Select source
        v-list-item
          v-list-item-avatar
            v-avatar(color="secondary")
              template(v-if="!blockSource.commited")
                strong.white--text 1
              template(v-else)
                v-icon(color="white") mdi-check-bold
          v-list-item-content
            v-card(
              flat
              v-on=`blockSource.commited ?
                { click: () => blockSource.commited = false }
                : {}`
            ).grey.lighten-5.pa-5.sdo-radius
              choice-source(
                v-model="blockSource"
                :date="date"
              )

        // Select audience
        v-scroll-y-transition
          v-list-item(
            v-if="blockSource.commited"
          )
            v-list-item-avatar
              v-avatar(color="secondary")
                template(v-if="!blockAudience.commited")
                  strong.white--text 2
                template(v-else)
                  v-icon(color="white") mdi-check-bold
            v-list-item-content
              v-card(
                flat
                v-on=`(blockAudience.commited || blockGroups.commited) ?
                  { click: () => { blockAudience.commited = false; blockGroups.commited = false; } }
                  : {}`
              ).grey.lighten-5.pa-5.sdo-radius
                choice-audience(
                  v-if="blockSource.conferenceSource === $conf.CONFERENCE_SOURCE.telegram"
                  v-model="blockAudience"
                )
                choice-groups(
                  v-else
                  v-model="blockGroups"
                )

        // Select lesson
        v-scroll-y-transition
          v-list-item(
            v-if="(blockAudience.commited && selectedCourse) || blockGroups.commited"
          )
            v-list-item-avatar
              v-avatar(color="secondary")
                template(v-if="!blockLesson.commited")
                  strong.white--text 3
                template(v-else)
                  v-icon(color="white") mdi-check-bold
            v-list-item-content
              v-card(
                flat
                v-on=`blockLesson.commited ?
                  { click: () => blockLesson.commited = false }
                  : {}`
              ).grey.lighten-5.pa-5.sdo-radius
                choice-lesson(
                  v-model="blockLesson"
                  :course="selectedCourse"
                  @back="blockAudience.commited = false"
                )

        // Create a translation
        v-scroll-y-transition
          v-list-item(v-if=`
            blockLesson.commited || (blockAudience.commited && !selectedCourse)`
          )
            v-list-item-avatar
              v-avatar(color="secondary")
                strong.white--text {{ selectedCourse ? 4 : 3 }}
            v-list-item-content
              v-card(flat).grey.lighten-5.pa-5.sdo-radius
                conference-form-telegram(
                  v-if="blockSource.conferenceSource === $conf.CONFERENCE_SOURCE.telegram"
                  :date="date"
                  :lesson="blockLesson.lesson"
                  :audience="blockAudience"
                  @on-success="onSuccess"
                )
                conference-form-jazz(
                  v-else
                  :date="date"
                  :lesson="blockLesson.lesson"
                  :groups="blockGroups.groups"
                  @on-success="onSuccess"
                )
</template>

<script>
import ChoiceSource from './ChoiceSource.vue';
import ChoiceAudience from './ChoiceAudience.vue';
import ChoiceLesson from './ChoiceLesson.vue';
import ChoiceGroups from './ChoiceGroups.vue';
import ConferenceFormTelegram from './ConferenceFormTelegram.vue';
import ConferenceFormJazz from './ConferenceFormJazz.vue';

export default {
  name: 'ConferenceForm',
  components: {
    ChoiceLesson,
    ChoiceSource,
    ChoiceAudience,
    ChoiceGroups,
    ConferenceFormTelegram,
    ConferenceFormJazz,
  },
  props: {
    date: { type: String, default: null },
  },
  data() {
    return {
      blockSource: { commited: false },
      blockGroups: { commited: false },
      blockAudience: { commited: false },
      blockLesson: { commited: false },
    };
  },
  computed: {
    selectedCourse() {
      if (this.blockAudience.courses?.length === 1) {
        const [course] = this.blockAudience.courses;
        return course;
      }
      if (this.blockGroups.course) return this.blockGroups.course;
      return null;
    },
  },
  watch: {
    blockSource: {
      handler() {
        this.blockGroups = { commited: false };
        this.blockAudience = { commited: false };
      },
      deep: true,
    },
    blockGroups: {
      handler() {
        this.blockLesson = { commited: false };
      },
      deep: true,
    },
  },
  methods: {
    onSuccess() {
      return this.$router.push({
        name: 'Schedule',
      });
    },
  },
};
</script>
